import $ from "jquery";
import "slick-carousel";


const testSlider = 'home-promos-slider';

$(`.${testSlider}`).on("init beforeChange", function (event, slick) {
  if (slick.$dots) {
    const dots = slick.$dots.find("li");
    const theme = $(`.controls-dots-${testSlider}`).data("theme");
    dots.addClass('slick-dot ' + theme);
  }
});


$(`.${testSlider}`).slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: true,
  adaptiveHeight: true,
  appendDots: $(`.controls-dots-${testSlider}`),
  nextArrow: $(`.controls-next-${testSlider}`),
  prevArrow: $(`.controls-prev-${testSlider}`),
});

// Promo images can finish (lazy) loading after slick has set the adaptive
// height, which cuts off full-height banners until the slide changes.
// Recalculate the height whenever a promo image loads.
const $promoSlider = $(`.${testSlider}`);

if ($promoSlider.length > 0) {
  const refreshHeight = () => {
    if ($promoSlider.hasClass('slick-initialized')) {
      $promoSlider.slick('setPosition');
    }
  };

  $promoSlider.find('img').on('load', refreshHeight);
  $(window).on('load', refreshHeight);
}
